import React, { Component } from "react";
import { Div, Image, Text, Icon, Modal } from "atomize";
import Swiper from "react-id-swiper";
// import {
//   Player,
//   ControlBar,
//   CurrentTimeDisplay,
//   TimeDivider,
//   VolumeMenuButton,
// } from "video-react";

import PrimaryButton from "../components/common/PrimaryButton";
import ModalVideo from "./ModalVideo";
import ImageLink from "../components/common/ImageLink";
// import { IsValidUrl } from "../utilities/helpers";
import AnimateLink from "../components/common/AnimateLink";

const params = {
  slidesPerView: 1,
  // grabCursor: false,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  // mousewheel: {
  //   forceToAxis: true,
  //   invert: true,
  //   releaseOnEdges: true,
  // },
  renderPrevButton: () => <Div className="swiper-button-prev"></Div>,
  renderNextButton: () => <Div className="swiper-button-next"></Div>,
};

// const videoParams = {
//   fluid: false,
//   playsInline: true,
//   isFullScreen: true,
// };

class HomeVideoModal extends Component {
  videoPlayer = [];

  pause = () => {
    this.videoPlayer.forEach(video => {
      video.pause();
    });
  };

  renderSlider = media => {
    const type = media.__typename;

    switch (type) {
      case "ContentfulImage":
        return (
          <ImageLink link={media.image.description}>
            <Div
              className="image-card"
              bgImg={media.image.file.url}
              bgSize="cover"
              bgRepeat="no-repeat"
              bgColor="black"
              bgPos="center"
              p={{ b: { xs: "120%", md: "120%", lg: "120%" } }}
              pos="relative"
            ></Div>
          </ImageLink>
        );
      case "ContentfulVideo":
        return (
          <ModalVideo
            poster={media.image.file.url}
            source={media.video.file.url}
          />

          // <Div pos="relative" bg="black" p={{ b: "120%" }}>
          //   <Div
          //     pos="absolute"
          //     top="0"
          //     left="0"
          //     w="100%"
          //     h="100%"
          //     d="flex"
          //     align="center"
          //     zIndex="1"
          //   >
          //     <Player
          //       {...videoParams}
          //       ref={videoPlayer => {
          //         this.videoPlayer.push(videoPlayer);
          //         console.log("came here 2");
          //       }}
          //       poster={media.image.file.url}
          //       className="video-modal"
          //     >
          //       <source src={media.video.file.url} />

          //       <ControlBar>
          //         <CurrentTimeDisplay order={4.1} />
          //         <TimeDivider order={4.2} />
          //         <VolumeMenuButton order={8} />
          //       </ControlBar>
          //     </Player>
          //   </Div>
          // </Div>
        );
    }
  };

  render() {
    const { isOpen, onClose, card } = this.props;

    return (
      <Modal
        className="image-video-modal"
        isOpen={isOpen}
        onClose={onClose}
        align="flex-start"
        rounded="sm"
        shadow="modalShadow"
        maxW={{ xs: "calc(100% - 2rem)", md: "70vw", lg: "59.1rem" }}
        p="0"
        textColor="black"
        overflow="visible"
        m={{ xs: "2rem 1rem 1rem", md: "1rem", lg: "auto" }}
      >
        <Icon
          d={{ xs: "none", lg: "block" }}
          name="Cross"
          pos="absolute"
          top="0.75rem"
          right="1rem"
          size="28px"
          onClick={onClose}
          cursor="pointer"
          color="black"
          zIndex="100"
        />
        <Icon
          d={{ xs: "block", lg: "none" }}
          name="Cross"
          pos="absolute"
          top={{ xs: "-2rem", md: "0rem" }}
          right={{ xs: "-0.5rem", md: "-2.5rem" }}
          size="28px"
          onClick={onClose}
          cursor="pointer"
          color="white"
          zIndex="100"
        />
        <Div d="flex" flexDir={{ xs: "column", lg: "row" }}>
          <Div flexGrow="1" maxW={{ xs: "100%", lg: "50%" }}>
            <Swiper {...params}>
              {card.media.map((mediaitem, index) => (
                <div key={`slider-${index}`}>
                  {this.renderSlider(mediaitem)}
                </div>
              ))}
            </Swiper>
          </Div>
          <Div
            className="modal-body-content"
            flexGrow="1"
            maxW={{ xs: "100%", lg: "50%" }}
          >
            <Div textAlign="center" m={{ t: "1.5rem" }}>
              <ImageLink link={card.companyLogo.description}>
                <Image
                  alt={
                    card.companyLogo.file.description &&
                    card.companyLogo.file.description
                  }
                  src={card.companyLogo.file.url}
                  h="3.5rem"
                  w="auto"
                />
              </ImageLink>
            </Div>
            <Div
              m={{ t: "1.25rem" }}
              d="flex"
              border={{ t: "1px solid" }}
              borderColor="gray400"
            >
              <Div textAlign="center" flexGrow="1" p={{ y: "0.75rem" }}>
                <Text textWeight="700" textSize="display1">
                  {card.postsCount}
                </Text>
                <Text
                  fontFamily="secondary"
                  textSize="caption1"
                  m={{ t: "-0.25rem" }}
                >
                  Social Posts
                </Text>
              </Div>
              <Div
                textAlign="center"
                flexGrow="1"
                p={{ y: "0.75rem" }}
                border={{ l: "1px solid" }}
                borderColor="gray400"
              >
                <Text textWeight="700" textSize="display1">
                  {card.piecesCount}
                </Text>
                <Text
                  fontFamily="secondary"
                  textSize="caption1"
                  m={{ t: "-0.25rem" }}
                >
                  Pieces of Content
                </Text>
              </Div>
            </Div>
            <Div d="flex" border={{ y: "1px solid" }} borderColor="gray400">
              <Div textAlign="center" flexGrow="1" p={{ y: "1.22rem" }}>
                <Text textWeight="700" textSize="subheader2">
                  {card.totalImpressions}
                </Text>
                <Text
                  fontFamily="secondary"
                  textSize="caption1"
                  m={{ t: "0.1rem" }}
                >
                  Total Impressions
                </Text>
              </Div>
              <Div
                textAlign="center"
                flexGrow="1"
                p={{ y: "1.22rem" }}
                border={{ l: "1px solid" }}
                borderColor="gray400"
              >
                <Text textWeight="700" textSize="subheader2">
                  {card.totalLikes}
                </Text>
                <Text
                  fontFamily="secondary"
                  textSize="caption1"
                  m={{ t: "0.1rem" }}
                >
                  Total Likes
                </Text>
              </Div>
              <Div
                textAlign="center"
                flexGrow="1"
                p={{ y: "1.22rem" }}
                border={{ l: "1px solid" }}
                borderColor="gray400"
              >
                <Text textWeight="700" textSize="subheader2">
                  {card.totalComments}
                </Text>
                <Text
                  fontFamily="secondary"
                  textSize="caption1"
                  m={{ t: "0.1rem" }}
                >
                  Total Comments
                </Text>
              </Div>
            </Div>
            <Text
              textSize="paragraph"
              p={{ x: { xs: "1.5rem", md: "2.25rem" }, t: "2.25rem" }}
              textAlign="center"
            >
              {card.description}
            </Text>
            <Div textAlign="center" m={{ t: "2.25rem", b: "2rem" }}>
              <AnimateLink to={card.linkUrl}>
                <PrimaryButton
                  bg="primary"
                  hoverBg="primary700"
                  textColor="black"
                  textTransform="none"
                  border="none"
                  p={{ x: "1.2rem" }}
                  h="3rem"
                  m="0 auto"
                >
                  <Text tag="span">Get Started Now</Text>
                </PrimaryButton>
              </AnimateLink>
            </Div>
          </Div>
        </Div>
      </Modal>
    );
  }
}

export default HomeVideoModal;
